import translate from '@translate';
import React, { FC } from 'react';
import BodyTopBlock from 'src/components/BodyTopBlock';
import { HideIcon, ShowIcon } from 'src/components/SkladonIcon/SmallIcons';
import { ApplicationStatusMessageType } from 'src/types/applicationStatusMessage';

export interface TopBlockPropsType {
    data: ApplicationStatusMessageType | null;
    idApplicationStatusMessage: string | undefined;
    newApplicationStatusMessage: boolean;
    disableEdit: boolean;
    disableDelete: boolean;
    handleSave: () => void;
    toggleActivateProduct: () => void;
}

const TopBlock: FC<TopBlockPropsType> = (props) => {
    return (
        <>
            <BodyTopBlock
                actions={[
                    {
                        tooltip: translate('applicationStatusMessageDetail.activate'),
                        onClick: props.toggleActivateProduct,
                        icon: <ShowIcon />,
                        hidden: props.newApplicationStatusMessage || !!props.data?.ACTIVE,
                        variant: 'outlined',
                    },
                    {
                        tooltip: translate('applicationStatusMessageDetail.deactivate'),
                        onClick: props.toggleActivateProduct,
                        icon: <HideIcon />,
                        hidden: props.newApplicationStatusMessage || !props.data?.ACTIVE,
                        variant: 'outlined',
                    },
                    {
                        label: translate(
                            props.newApplicationStatusMessage
                                ? 'applicationStatusMessageDetail.create'
                                : 'applicationStatusMessageDetail.save'
                        ),
                        onClick: () => {
                            props.handleSave();
                        },
                        hidden: props.disableEdit,
                    },
                ]}
            />
        </>
    );
};

export default TopBlock;
